<div class="content">

    <!--<input type="button" (click)="addItemsToReport()" value="Add New Item" />-->

    <div class="button-container">
        <div class="button-container__left" (click)="viewInspection()" *ngIf="equipmentId > 0">
            <a class="button waves-effect"><span class="button__text">View Inspection</span></a>
        </div>
        <!-- <div  *ngIf ="!IsReleased" class="button-container__right">
            <a class="button button--primary waves-effect" (click)="ReleaseReport()"><span class="button__text">Release</span></a>
        </div> -->
        <div class="button-container__right">
            
            <a *ngIf ="IsReleased" class="button button--primary waves-effect" (click)="sendReport()"><span class="button__text">Send Report</span></a>
           
            <!--<a class="button waves-effect"><i class="material-icons">more_vert</i></a>-->
            <a *ngIf ="!IsReleased" class="button button--primary waves-effect" (click)="ReleaseReport()"><span class="button__text">Release</span></a>
            <a class="button waves-effect"  target="_blank" href="/api/msinspection/getpdf?inspectionId={{MSInspectionID}}&uom={{pdfUoM}}&styleId={{ropeStyleId}}"><span class="button__text">Preview</span></a>
        </div>
       
    </div>

    <div class="panel" style="position: relative">
        <div id="frontpage">
            <img *ngIf="ropeStyleId==1" src="Content/Images/RSImages/TT_report_front.png" style="width: 1424px; height: 1692px; margin: 8px;" />
            <img *ngIf="ropeStyleId==2" src="Content/Images/RSImages/LnH_report_front.png" style="width: 1424px; height: 1692px; margin: 8px;" />
            <img *ngIf="ropeStyleId==3" src="Content/Images/RSImages/Suncor_report_front.png" style="width: 1424px; height: 1692px; margin: 8px;" />
            <img *ngIf="ropeStyleId==4" src="Content/Images/RSImages/Mainetec_report_front.png" style="width: 1424px; height: 1692px; margin: 8px;" />

            <!-- <img src="uc-ng-app/dist/assets/LnH_report_front.png" style="width: 1424px; height: 1692px; margin: 8px;" /> -->

            <div id="equipment_photo" (click)="addPhotoToReport()">
                <p>CHANGE EQUIPMENT PHOTO</p>
                <img [(src)]="equipmentPhoto" style="max-width:540px; max-height: 360px; padding: 10px;" />
            </div>
            <div id="inspection_summary_details" style="position: absolute; left: 495px; top: 1375px; z-index: 2;">
                <span style="font-size: 28px; text-transform: uppercase;"><b>{{equipmentJobsite}}</b></span><br />
                <span style="font-size: 28px; text-transform: uppercase;"><b>{{equipmentMake}} {{equipmentModel}} Unit {{unitNumber}}</b></span><br />
                <span>{{dateOfInspection | date: 'dd-MMM-yyyy' }}</span><br />
                <span>Performed By: {{UCInspector}}</span><br />
            </div>
        </div>

        <div class="report_content">
            <div id="introduction">
                <span class="section-title">1. Introduction</span>
                <div class="section-content">
                    <edit-data [canEdit]="true" (clickOut)="saveIntroText1($event)" [value]="reportIntroduction.IntroText1" [dataType]="'textarea'" [vertResizeOnly]="true"></edit-data>
                </div>

                <!--<div class="add-section">
                    <a class="button waves-effect" (click)="addItemsToReport()" style="width: 100%; display: flex; justify-content: center; align-items: center">
                        <i class="material-icons button__icon">add</i>
                        <span class="button__text btnIconText">Add Photo</span>
                    </a>
                </div>-->

                <ng-container *ngFor="let imp of inspectionMandatoryPhotos">
                    <ng-container *ngIf="imp.data != ''">
                        <measurement-point-photos [figure_number]="0" [image_id]="imp.id" [image_data]="imp.data" [image_title]="imp.title" [image_comment]="imp.comment"
                                (EditPhotoComment) = "changedInspectionMandatoryPhotoComment($event)"   [isHidden]="imp.isHidden" (togglePhoto)="toggleInspectionMandatoryPhoto(imp.id)"
                                                  [isLarge]="imp.isLarge" (toggleResize)="resizeInspectionMandatoryImage($event, imp.id)"></measurement-point-photos>
                    </ng-container>
                </ng-container>

                <div class="section-content">
                    <edit-data [canEdit]="true" (clickOut)="saveIntroText2($event)" [value]="reportIntroduction.IntroText2" [dataType]="'textarea'" [vertResizeOnly]="true"></edit-data>
                </div>
            </div>

            <div id="measurements">
                <span class="section-title">2. Measurements</span>

                <div *ngFor="let UCComp of UCComponents">

                    <div  class="section-title-component">
                        {{Translate(UCComp.componentName)}}
                    </div>

                    <div class="section-content">
                        <edit-data [canEdit]="true" [value]="UCComp.destination.OverallComments.Comments" (clickOut)="saveOverallComments($event, UCComp.destination)" 
                                   [placeholderText]="'Overall comments for '+UCComp.componentName" [dataType]="'textarea'" [vertResizeOnly]="true"></edit-data>
                    </div>

                    <div *ngIf="UCComp.destination.MandatoryImages?.length > 0">
                        <div class="section-title-measurement-point">Mandatory Images</div>
                        <div *ngFor="let MI of UCComp.destination.MandatoryImages">
                            <measurement-point-photos [figure_number]="'0'" [image_id]="MI.id" [image_data]="MI.data" [image_title]="MI.title" [image_comment]="MI.comment"
                            (EditPhotoComment) = "changeMandatoryImageComments($event)"                      [isHidden]="MI.isHidden" (togglePhoto)="toggleComparttypeMandatoryPhoto(MI.id)"
                                                      [isLarge]="MI.isLarge" (toggleResize)="resizeComparttypeMandatoryImage($event, MI.id)"></measurement-point-photos>
                        </div>
                    </div>

                    <div *ngIf="UCComp.destination.AdditionalRecords?.length > 0">
                        <div class="section-title-measurement-point">Additional Records</div>
                        <additional-record [ARDetails]="UCComp.destination.AdditionalRecords" [UoM]="readingUoM" [CompartType]="UCComp.componentId"
                                           [isHidden]="UCComp.destination.isAdditionalRecordsHidden" (toggleData)="toggleComparttypeAdditionalRecord($event)"></additional-record>
                    </div>

                    <div *ngIf="UCComp.destination.AdditionalImages?.length > 0">
                        <div class="section-title-measurement-point">Additional Images</div>
                        <div *ngFor="let AI of UCComp.destination.AdditionalImages">
                            <measurement-point-photos [figure_number]="'0'" [image_id]="AI.id" [image_data]="AI.data" [image_title]="AI.title" [image_comment]="AI.comment"
                            (EditPhotoComment) = "changeAdditionalImageComment($event, AI)"                    [isHidden]="AI.isHidden" (togglePhoto)="toggleComparttypeAdditionalPhoto($event)"
                                                      [isLarge]="AI.isLarge" (toggleResize)="resizeComparttypeAdditionalImage($event, AI.id)"></measurement-point-photos>
                        </div>
                    </div>

                    <div *ngFor="let MP of UCComp.destination.MeasurementPoints" class="measurement-point">
                        <div *ngIf="MP.Readings.length > 0 && MP.Readings[0].listOfReadings.length >0" [class.not-selected]="MP.isHidden">
                            <div class="section-title-measurement-point">
                                <mat-checkbox #checkbox (change)='toggleShowOrHideMP(checkbox.checked, MP)' [checked]="MP.isHidden ? false : true" class="notes-title">{{MP.MeasurePointName}}</mat-checkbox>  
                            </div>

                            <ng-container *ngFor="let mpr of MP.Readings">
                                <ng-container *ngIf="(mpr.measurePointId == MP.MeasurePointId) && (mpr.totalCount > 0)">
                                    <measurement-point-readings [CompartName]="UCComp.componentName" [UoM]="readingUoM" [measurePointId]="MP.MeasurePointId" [measure_point_title]="MP.MeasurePointName" [totalReadings]="mpr.totalCount" [readings]="mpr.listOfReadings"
                                                     [tool]="mpr.tool" [isHidden]="mpr.isHidden" (toggleData)="toggleMeasurementPointRecord($event)"></measurement-point-readings>
                                </ng-container>
                            </ng-container>

                            <ng-container *ngFor="let mpo of MP.Observations">
                                <div  *ngIf="(mpo.measurePointId == MP.MeasurePointId) && mpo.observation" class="section-content" >
                                      <mat-checkbox #checkbox (change)='showMeasurementPointNoteSec(checkbox.checked, mpo)' [checked]="mpo.isShow" class="notes-title">Notes - {{mpo.desc}} ({{mpo.side}})</mat-checkbox>
                                        <edit-data [canEdit]="false" [value]="mpo.observation" [dataType]="'textarea'" [vertResizeOnly]="true"></edit-data>
                                </div>
                            </ng-container>

                            <ng-container *ngFor="let mpi of MP.Images">
                                <!--<ng-container *ngIf="mpi.measurePointId == MP.MeasurePointId">
                                    <measurement-point-photos [figure_number]="0" [image_data]="mpi.imageData" [image_title]="mpi.imageTitle" [image_comment]="mpi.imageComment"></measurement-point-photos>
                                </ng-container>-->
                                <measurement-point-photos [figure_number]="0" [image_id]="mpi.id" [image_data]="mpi.data" [image_title]="mpi.title" [image_comment]="mpi.comment"
                                (EditPhotoComment) = "changedMeasurementPointsPhotoComment($event)"                  [isHidden]="mpi.isHidden" (togglePhoto)="toggleMeasurementPointPhoto($event)"
                                                          [isLarge]="mpi.isLarge" (toggleResize)="resizeMeasurementPointImage($event, mpi.id)"></measurement-point-photos>
                            </ng-container>

                            <!-- <div class="show-hide-toggle" (click)="toggleShowOrHideMP(MP)" matTooltip="Toggle Show or Hide">
                                <i class="material-icons show-hide-toggle__icon">not_interested</i>
                            </div> -->
                        </div>
                    </div>

                    <div *ngIf="(UCComp.destination.CalculatedRecords?.length > 0) && (showAxialGapCalculations == true)">
                        <div class="section-title-measurement-point">Calculated Axial Gap</div>
                        <additional-record [ARDetails]="UCComp.destination.CalculatedRecords" [UoM]="readingUoM" [CompartType]="UCComp.componentId" [hideToggle]="true"></additional-record>
                    </div>

                </div>


                <!--<div class="add-section">
                    <a class="button waves-effect" (click)="addItemsToReport()" style="width: 100%; display: flex; justify-content: center; align-items: center">
                        <i class="material-icons button__icon">add</i>
                        <span class="button__text btnIconText">Add Photo or Measurement</span>
                    </a>
                </div>-->
            </div>

            <div id="summary">
                <span class="section-title">3. Summary</span>
                <div class="section-content">
                    <edit-data [canEdit]="true" [value]="reportSummary.SummaryText" [placeholderText]="'Write a summary for this inspection.'" 
                               (clickOut)="saveReportSummary($event)" [dataType]="'textarea'" [vertResizeOnly]="true"></edit-data>
                </div>
            </div>

            <div id="recommended_actions">
                <span class="section-title">4. List of Recommended Actions</span>
                <div class="section-content">
                    <edit-data [canEdit]="true" [value]="reportSummary.RecommendationOverview" [placeholderText]="'Write an overview of recommendations here.'" 
                               (clickOut)="saveReportRecommendationOverview($event)" [dataType]="'textarea'" [vertResizeOnly]="true"></edit-data>
                </div>

                <ng-container *ngFor="let rcm of recommendedActions">
                    <div class="section-content">
                        <recommended-action [rcmAction]="rcm" (recommendationUpdated)="saveRecommendation($event)" (recommendationDeleted)="deleteRecommendation($event)" [inspectionID]="MSInspectionID"></recommended-action>
                    </div>
                </ng-container>

                <div class="add-section">
                    <a class="button waves-effect" (click)="addNewRecommendation()" style="width: 100%; display: flex; justify-content: center; align-items: center">
                        <i class="material-icons button__icon">add</i>
                        <span class="button__text btnIconText">Add Recommendation</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>